import { useDebouncedCallback } from '@carvana/merch-react-hooks';
import {
  type FavoritesArguments,
  type LifeCycleFn,
  useToggleFavorite as useToggleFavoriteCommon
} from '~/hooks/common/favorites';
import { useBeforeRemoveFavorite } from '~/hooks/vdp/favorites/useRemoveFavorite';

type Options = {
  onAddFavorite?: LifeCycleFn;
};

export default function useToggleFavorite(
  opts: Options = {}
): (args: FavoritesArguments) => void {
  const toggleFavorite = useToggleFavoriteCommon({
    beforeAddFavorite: useBeforeRemoveFavorite(),
    beforeRemoveFavorite: useBeforeRemoveFavorite(),
    onAddFavorite: opts.onAddFavorite
  });

  return useDebouncedCallback(toggleFavorite, [toggleFavorite], 500, {
    leading: true,
    trailing: false
  });
}
